import React, { useEffect } from 'react';
import { get, post } from '../../utils/http';
import api from '../../utils/api';
import { Modal, Input, Select, Button, notification, Upload, DatePicker, Form, Space } from 'antd'
import { sessionManager } from '../../core/SessionManager';
import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;
const { confirm } = Modal;
const { TextArea } = Input;

export default function CreateNewIssue(props) {
  const [categoryList, setCategoryList] = React.useState([]);
  const [typeList, setTypeList] = React.useState([]);
  const [category, setCategory] = React.useState('');
  const [type, setType] = React.useState('');
  const [counterCode, setCounterCode] = React.useState('');
  const [dateAndTime, setDateAndTime] = React.useState('');
  const [personInCharge, setPersonInCharge] = React.useState('');
  const [contactNumber, setContactNumber] = React.useState('');
  const [contactEmail, setContactEmail] = React.useState('');
  const [content, setContent] = React.useState('');
  const [attachmentId, setAttachmentId] = React.useState("");
  const [fileList, setFileList] = React.useState([]);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [isGetData, setIsGetData] = React.useState(false);

  useEffect(() => {
    if (!isGetData) {
      post(api.queryIssueList).then(function (response) {
        setCategoryList(response.categoryLists)
        setTypeList(response.typeLists)
        setIsGetData(true)
      }).catch(function (error) {
        notification['error']({
          message: 'Fail to get data.',
        });
        console.log(error);
      })
    }

  }, [isGetData])


  const uploadPro = {
    name: "file",
    action: api.uploadFile,
    headers: {
      Authorization: 'Bearer '+ sessionManager.getToken(),
      merchantId: sessionManager.getMerchantId()
    },
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList)
      // if (info.file.status === "done") {
      //   setAttachmentId(info.file.response.data.files[0].fileId)
      // }
    }
  };

  const handleSubmit = () => {//submit button

    setConfirmLoading(true)
    const createData = {
      category,
      type,
      counterCode,
      dateAndTime,
      personInCharge,
      contactNumber,
      contactEmail,
      content,
      attachmentId,
      merchantId: sessionManager.getMerchantId(),
      creationUser: sessionManager.getMerchantName(),
      displayTrue: { style: { display: "inline-block" } },
      displayFalse: { style: { display: "none" } },
      modalFooter: {}
    }
    post(api.createIssue, createData).then(function (response) {
      notification['success']({
        message: 'Create successfully.',
      });
      props.closeCreateModal()
      props.handleSearch()
      setIsGetData(false);
      setConfirmLoading(false)
    }).catch(function (error) {
      notification['error']({
        message: 'Fail to create.',
      });
      console.log(error)
      setConfirmLoading(false)
    })
  }

  const checkEmail = (value) => {
    if (value !== "" && !(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/.test(value))) {
      notification['warning']({
        message: 'Please input correct email!',
      });
    }
  }

  const checkContent = (value) => {
    if (value === "") {
      notification['warning']({
        message: 'Please input More Information!',
      });
    }
  }

  const handleCancle = () => {
    confirm({
      content: "Are you sure to close this modal?",
      onOk() {
        Modal.destroyAll();
        props.closeCreateModal();
      }
    });
  };

  const checkNum = (event) => {
    var reg = /^[0-9]$/;
    if (reg.test(event.nativeEvent.data)) {
      setContactNumber(event.target.value)
    }
  }


  return (
    <>
      <Modal
        title="Service Request"
        visible={props.isOpenCreate}
        confirmLoading={confirmLoading}
        destroyOnClose={true}
        onCancel={handleCancle}
        footer={null}
      >
        <Form
          name="basic"
          onFinish={handleSubmit}
          labelCol={{ span: 7 }}
          autoComplete="off"
          >
          <Form.Item
            name="Service category"
            label="Service category"
            rules={[{ required: true, message: 'Please select Service category!' }]}
            >
            <Select
              placeholder="category"
              onChange={value => setCategory(value)}
              
            >
              {categoryList.map((category) => {
                return (
                  <Option value={category.categoryId}>{category.categoryName}</Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="Service Type"
            label="Service Type"
            rules={[{ required: true, message: 'Please select Service Type!' }]}
            >
            <Select
              placeholder="type"
              onChange={value => setType(value)}
              
            >
              {typeList.map((type) => {
                return (
                  <Option value={type.typeId}>{type.typeName}</Option>
                )
            })}
          </Select>
          </Form.Item>
          <Form.Item
            name="Counter Code"
            label="Counter Code"
            >
            <Input placeholder="counter code" onChange={event => setCounterCode(event.target.value)} />
          </Form.Item>
          <Form.Item
            name="Date and Time"
            label="Date and Time"
            >
            <DatePicker showTime onChange={(value, dateString) => { setDateAndTime(value) }} />
          </Form.Item>
          <Form.Item
            name="Person in charge"
            label="Person in charge"
            >
            <Input placeholder="person name" onChange={event => setPersonInCharge(event.target.value)}/>
          </Form.Item>
          <Form.Item
            name="Contact number"
            label="Contact number"
            >
            <Input placeholder="contact number" value={contactNumber} onChange={checkNum} />
          </Form.Item>
          <Form.Item
            name="Contact Email"
            label="Contact Email"
            >
            <Input placeholder="contact email" onBlur={event => checkEmail(event.target.value)} onChange={event => setContactEmail(event.target.value)}/>
          </Form.Item>
          <Form.Item
            name="More Information"
            label="More Information"
            rules={[{ required: true, message: 'Please input your more information!' }]}>
            <TextArea placeholder="more information" onBlur={event => checkContent(event.target.value)} onChange={event => setContent(event.target.value)} style={{ height: "100px"}} />
          </Form.Item>
          <Form.Item
            name="Attachment"
            label="Attachment"
            >
            <Upload {...uploadPro} fileList={fileList} >
              <Button startIcon={<UploadOutlined />} variant="contained" style={{ height: "40px", textAlign: "right", marginTop: "6px", backgroundColor: "#f8f8f8" }}>Upload</Button>
            </Upload>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 16, span: 16 }}>
            <Space>
              <Button size="large" htmlType="button" onClick={handleCancle}>
                Cancel
              </Button>
              <Button size="large" type="primary" htmlType="submit" >
                OK
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
